export default function EditDepartmentDialogController(
  $q,
  $scope,
  $rootScope,
  $filter,
  $timeout,
  ssDialogService,
  alerts,
  userService,
  loaderService,
  emDataService,
  selectTeamMembersDialog,
  editProcessDialog
) {
  const vm = this;

  vm.closeDialog = _closeDialog;
  vm.saveDepartment = _saveDepartment;
  vm.handleAddTeamMember = _handleAddTeamMember;
  vm.handleEditDepartmentFormSubmit = _handleEditDepartmentFormSubmit;
  vm.handleAddProcess = _handleAddProcess;
  vm.handleCloseDialog = _handleCloseDialog;

  _activate();

  _initializeViewModel();

  function _activate() {
    _initPermissions();

    $scope.$on('refreshProcesses', ($event, obj) => {
      if (vm.department.departmentId === obj.departmentId) {
        _refreshProcesses();
      }
    });
  }

  function _initPermissions() {
    userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.hasBCPAccess = permissions.canEditAssessment;
    });
    userService.getUserPermissionSet('policyRiskAssessment').then((permissions) => {
      vm.hasPRAAccess = permissions.canEditAssessment;
    });
  }

  function _initializeViewModel() {
    vm.department.newName = vm.department.name;
    vm.department.departmentTeamMembers = $filter('filter')(
      vm.department.users, {
        isBCPDepartmentTeamMember: true,
      }
    );
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.enterpriseModeling.editDepartmentDialog);
  }

  function _saveDepartment() {
    const dfdSave = $q.defer();

    try {
      if ($scope.emEditDepartmentForm.$valid || $scope.emEditDepartmentForm.$pristine) {
        loaderService.showViewLoader = true;
        const teamMembers = [];
        const owners = [];
        angular.forEach(
          vm.department.users,
          (currentUser) => {
            if (currentUser.isBCPDepartmentTeamMember) {
              teamMembers.push(currentUser.userId);
            }
            if (currentUser.isBCPDepartmentOwner) {
              owners.push(currentUser.userId);
            }
          }
        );
        emDataService.saveDepartment(vm.department.departmentId, vm.department.newName, owners, teamMembers,
          vm.customerId)
          .then((saveDepartmentResponse) => {
            try {
              vm.department.name = vm.department.newName;
              vm.department.departmentId = saveDepartmentResponse.data;

              $rootScope.$broadcast('refreshDepartments');
              dfdSave.resolve({
                customerId: vm.customerId,
                department: vm.department,
                departmentId: vm.department.departmentId
              });
            } catch (error) {
              console.error(error);
            } finally {
              loaderService.showViewLoader = false;
            }
          }, () => {
            loaderService.showViewLoader = false;
          });
      } else {
        dfdSave.reject();
        loaderService.showViewLoader = false;
      }
    } catch (error) {
      console.error(error);
    }
    return dfdSave.promise;
  }

  function _refreshProcesses() {
    emDataService.getProcesses(vm.department.departmentId).then((response) => {
      vm.department.processes = response.data.result;
    });
  }

  function _handleAddTeamMember($event) {
    vm.department.name = vm.department.newName;
    ssDialogService.dialogs.enterpriseModeling.selectDepartmentTeamMembersDialog = ssDialogService.alert(
      selectTeamMembersDialog.getOptions($event, {
        customerId: vm.customerId,
        department: vm.department
      })
    );
    ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.selectDepartmentTeamMembersDialog);
  }

  function _handleEditDepartmentFormSubmit() {
    loaderService.showViewLoader = true;
    // Check form validity
    if (!$scope.emEditDepartmentForm.$valid) {
      loaderService.showViewLoader = false;
      $scope.emEditDepartmentForm.$submitted = false;
      return false;
    }

    vm.saveDepartment().then(() => {
      _broadcastChanges();
      loaderService.showViewLoader = false;
      $scope.emEditDepartmentForm.$submitted = false;

      switch (vm.saveType) {
        case 'saveAndClose':
          alerts.success('The department has been saved successfully.');
          vm.closeDialog();
          break;
        case 'save':
          alerts.success('The department has been saved successfully.');
          break;
        default:
          loaderService.showViewLoader = false;
      }
    });
  }

  function _broadcastChanges() {
      $rootScope.$broadcast('refreshDepartment', { department: vm.department });
      $timeout( // TODO: Get rid of this $timeout and fix the race condition
        () => {
          $rootScope.$broadcast('expandDepartment', { departmentId: vm.department.departmentId });
        }, 500
      );
  }

  function _handleAddProcess($event) {
    loaderService.showViewLoader = true;
    vm.saveDepartment().then((data) => {
      try {
        const process = {
          processId: 0,
          canEditProcess: true,
        };
        emDataService.getSuccessorOptions(process.processId).then((response) => {
          ssDialogService.dialogs.enterpriseModeling.editProcessDialog = ssDialogService.alert(
            editProcessDialog.getOptions($event, {
              customerId: data.customerId,
              department: data.department,
              process,
              isIt: false,
              successorOptions: response,
            })
          );
          ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.editProcessDialog);
        });
      } catch (error) {
        console.error(error);
      }
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }
}

EditDepartmentDialogController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  '$filter',
  '$timeout',
  'ssDialogService',
  'alerts',
  'userService',
  'loaderService',
  'emDataService',
  'selectTeamMembersDialog',
  'editProcessDialog'
];
